import { Box, Skeleton } from '@mui/material'
import NavigationSkeleton from './navigation-skeleton.component'
import { styles } from './layout-skeleton.styles'

/**
 * Layout Skeleton Component
 *
 * Shows only the navigation skeleton during initial auth loading.
 * The main content area is left empty because the page component
 * knows its own content (title, buttons, etc.) and can show it immediately.
 *
 * This prevents layout shift for the nav while allowing pages to render
 * their known content without waiting.
 */
export const LayoutSkeleton = ({ showNav = true }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        width: '100%',
        backgroundColor: 'gray.0',
      }}
    >
      {showNav && <NavigationSkeleton />}
      {/* Only the top bar every page shares; the page renders its own content */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          backgroundColor: 'gray.0',
        }}
      >
        {showNav && (
          <Box sx={styles.topBar} data-testid="layout-skeleton-top-bar">
            <Skeleton animation="wave" variant="rounded" width={240} height={14} />
            <Skeleton
              animation="wave"
              variant="rounded"
              width={190}
              height={28}
              sx={styles.locationPill}
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default LayoutSkeleton
